import {
    DescriptionRounded,
    FileDownloadRounded,
    FileUploadRounded,
    LibraryAddRounded,
    WarningRounded
} from "@mui/icons-material";
import * as React from "react";
import {useContext, useEffect, useMemo, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import AdvancedFilter from "../../component/AdvancedFilter";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";
import * as Yup from 'yup';
import {Box, Button, Checkbox, Grid, IconButton, ListItemText, MenuItem, TextField} from "@mui/material";
import {DatePicker} from "@mui/x-date-pickers";
import {useNavigate} from "react-router-dom";
import {useBlackListActions} from "../../service/useBlackListActions";
import {setSnackbar} from "../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../util/state/globalVariables";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import {ColDef, GetRowIdParams, GridOptions, ICellRendererParams, IServerSideGetRowsParams} from "ag-grid-enterprise";
import {useAgGridLocale, useHasScope} from "../../../../config/globalConfig";
import {AgGridReact} from "ag-grid-react";
import {CausalInterface, ClientTypeInterface, EntrySourceInterface} from "../../component/BlackListInterfaces";
import {useClientTypeValues} from "../../component/useClientTypeValues";
import {useCausalValues} from "../../component/useCausalValues";
import {useEntrySourceValues} from "../../component/useEntrySourceValues";
import EmptyState from "../../../../util/component/EmptyState";
import CustomModalBL from "../../component/CustomModalBL";
import FileUploader from "../../../../util/component/FileUploader";
import dayjs from "dayjs";
import CustomModalContent from "../../component/CustomModalContent";
import {
    BLACK_LIST_SCOPE_CREATE,
    BLACK_LIST_SCOPE_DETAIL_BL,
    BLACK_LIST_SCOPE_DOWNLOAD,
    BLACK_LIST_SCOPE_MASSIVE_ARCHIVE,
    BLACK_LIST_SCOPE_UPLOAD_FCA
} from "../../component/utils/AuthConstants";
import useToggle from "../../hooks/useToggle";
import DownloadModal from "./DownloadModal";
import MassiveArchiveModal from "./MassiveArchiveModal";

const BlackListPage = (props: any) => {

    const {t, i18n} = useTranslation(['finessecurity'], {keyPrefix: 'blackList'});
    const navigate = useNavigate();
    const {
        getBlackList,
        getBlackListArchived,
        getClientType,
        getCausalValues,
        getEntrySource,
        importFile,
        massiveArchiveUpload,
        downloadReport,
        downloadReportArchived
    } = useBlackListActions();
    const {globalData, dispatchGlobalData} = useContext(GlobalContext);
    const [blackListTableShouldUpdate, setBlackListTableShouldUpdate] = useState(false);
    const [uploadErrorMessage, setUploadErrorMessage] = useState<string>("");
    const [openUploadModal, setOpenUploadModal] = useState(false);
    const [openMassiveArchiveModal, setOpenMassiveArchiveModal] = useState(false);
    const [openMassiveArchiveAck, setOpenMassiveArchiveAck] = useState(false);
    const [disableButton, setDisableButton] = useState(true);
    const [openUploadWarning, setOpenUploadWarning] = useState(false);
    const agGridLocale = useAgGridLocale();
    const gridRef = useRef<AgGridReact>(null);
    const [searchInput, setSearchInput] = useState("");
    const [causalValues, setCausalValues] = useState<CausalInterface[]>([]);
    const [clientType, setClientType] = useState<ClientTypeInterface[]>([]);
    const [entrySource, setEntrySource] = useState<EntrySourceInterface[]>([]);
    const hasScope = useHasScope;
    const {getClientTypeLabel} = useClientTypeValues();
    const {getCausalLabel} = useCausalValues();
    const {getEntrySourcelLabel} = useEntrySourceValues();
    const [openDownloadModal, setOpenDownloadModal] = useToggle();

    const isArchived = props.archived;
    const [emptyBlackList, setEmptyBlackList] = useState<any>(null);
    const [doSearchFlag, setDoSearchFlag] = useState<boolean>(false);
    const [fileForImport, setFileForImport] = useState<File | undefined>(undefined);


    const filterDefaultValues = {
        customerName: "", clientType: [], entrySource: [], taxOrVat: "", siren: "", siret: "", causal: [],
        entryDateFrom: null, entryDateTo: null, startDateFrom: null,
        startDateTo: null, endDateFrom: null, endDateTo: null
    };
    const [filters, setFilters] = useState<any>(filterDefaultValues);

    const validationObj = {
        status: Yup.array(),
        segment: Yup.string().nullable(),
        entryDateFrom: Yup.date().nullable()
            .test("testEntryDateFrom", t('datesCheck'), (value, context) => {
                return (!value || !context.parent.entryDateTo || value <= context.parent.entryDateTo)
            })
            .typeError(t('invalidDate')),
        entryDateTo: Yup.date().nullable()
            .test("testEntryDateTo", t('datesCheck'), (value, context) => {
                return (!value || !context.parent.entryDateFrom || value >= context.parent.entryDateFrom)
            })
            .typeError(t('invalidDate')),
        startDateFrom: Yup.date().nullable()
            .test("testStartDateFrom", t('datesCheck'), (value, context) => {
                return (!value || !context.parent.startDateTo || value <= context.parent.startDateTo)
            })
            .typeError(t('invalidDate')),
        startDateTo: Yup.date().nullable()
            .test("testStartDateTo", t('datesCheck'), (value, context) => {
                return (!value || !context.parent.startDateFrom || value >= context.parent.startDateFrom)
            })
            .typeError(t('invalidDate')),
        endDateFrom: Yup.date().nullable()
            .test("testEndDateFrom", t('datesCheck'), (value, context) => {
                return (!value || !context.parent.endDateTo || value <= context.parent.endDateTo)
            })
            .typeError(t('invalidDate')),
        endDateTo: Yup.date().nullable()
            .test("testEndDateTo", t('datesCheck'), (value, context) => {
                return (!value || !context.parent.endDateFrom || value >= context.parent.endDateFrom)
            })
            .typeError(t('invalidDate')),
        name: Yup.string().nullable(),
        description: Yup.string().nullable()
    }

    const renderCustomerName = (field: any) => (
        <TextField
            fullWidth
            label={t('filters.customerName')}
            value={field.value}
            onChange={field.onChange}
        />
    )

    useEffect(() => {
        getCausalValues().then((res: any) => {
            setCausalValues(res.data);
        });
        getClientType().then((res: any) => {
            setClientType(res.data);
        });

        getEntrySource().then((res: any) => {
            setEntrySource(res.data);
        });

    }, []);

    const renderClientType = (field: any) => (
        <TextField
            fullWidth
            label={t('filters.clientType')}
            select
            SelectProps={{
                multiple: true,
                renderValue: (selected: any) => {
                    let result = clientType.length > 0 ? selected.map((l: any) =>
                        getClientTypeLabel(l)).join(", ") : "";
                    return result;
                },
            }}
            value={field.value}
            onChange={field.onChange}
        >
            {clientType?.map((l) => (
                <MenuItem key={l.client_type_code} value={l.client_type_code}>
                    <Checkbox color={"accent"} checked={field.value.indexOf(l.client_type_code) > -1}/>
                    <ListItemText primary={getClientTypeLabel(l.client_type_code)}/>
                </MenuItem>
            ))}

        </TextField>
    )
    const renderEntrySource = (field: any) => (
        <TextField
            fullWidth
            label={t('filters.entrySource')}
            select
            SelectProps={{
                multiple: true,
                renderValue: (selected: any) => {
                    let result = entrySource.length > 0 ? selected.map((l: any) =>
                        getEntrySourcelLabel(l)).join(", ") : "";
                    return result;
                },
            }}
            value={field.value}
            onChange={field.onChange}
        >
            {entrySource?.map((l) => (
                <MenuItem key={l.entry_origin_code} value={l.entry_origin_code}>
                    <Checkbox color={"accent"} checked={field.value.indexOf(l.entry_origin_code) > -1}/>
                    <ListItemText primary={getEntrySourcelLabel(l.entry_origin_code)}/>
                </MenuItem>
            ))}
        </TextField>
    )
    const renderTaxOrVat = (field: any) => (
        <TextField
            fullWidth
            label={t('filters.taxOrVat')}
            value={field.value}
            onChange={field.onChange}
        />
    );
    const renderSiren = (field: any) => (
        <TextField
            fullWidth
            label={t('filters.siren')}
            value={field.value}
            onChange={field.onChange}
        />
    );
    const renderSiret = (field: any) => (
        <TextField
            fullWidth
            label={t('filters.siret')}
            value={field.value}
            onChange={field.onChange}
        />
    );
    const renderCausal = (field: any) => (
        <TextField
            fullWidth
            label={t('filters.causal')}
            select
            SelectProps={{
                multiple: true,
                renderValue: (selected: any) => {
                    let result = causalValues.length > 0 ? selected.map((l: any) =>
                        getCausalLabel(l)).join(", ") : "";
                    return result;
                },
            }}
            value={field.value}
            onChange={field.onChange}
        >
            {causalValues?.map((l) => (
                <MenuItem key={l.causal_code} value={l.causal_code}>
                    <Checkbox color={"accent"} checked={field.value.indexOf(l.causal_code) > -1}/>
                    <ListItemText primary={getCausalLabel(l.causal_code)}/>
                </MenuItem>
            ))}
        </TextField>
    );
    const renderEntryDateFrom = (field: any, error: any, formState: any, values: any) => (
        <DatePicker
            views={['day']}
            label={t('filters.entryDateFrom')}
            value={field.value}
            onChange={field.onChange}
            maxDate={values["entryDateTo"] ? values["entryDateTo"] : ""}
            renderInput={(params) =>
                <TextField {...params} fullWidth
                           id={"entryDateFrom"}
                           error={error !== undefined}
                           helperText={error ? error.message : ""}
                />} inputFormat={"L"}
        />)
    const renderEntryDateTo = (field: any, error: any, formState: any, values: any) => (
        <DatePicker
            views={['day']}
            label={t('filters.entryDateTo')}
            value={field.value}
            onChange={field.onChange}
            minDate={values["entryDateFrom"] ? values["entryDateFrom"] : ""}
            renderInput={(params) =>
                <TextField {...params} fullWidth
                           id={"entryDateTo"}
                           error={error !== undefined}
                           helperText={error ? error.message : ""}
                />} inputFormat={"L"}
        />)
    const renderStartDateFrom = (field: any, error: any, formState: any, values: any) => (
        <DatePicker
            views={['day']}
            label={t('filters.startDateFrom')}
            value={field.value}
            onChange={field.onChange}
            maxDate={values["startDateTo"] ? values["startDateTo"] : ""}
            renderInput={(params) =>
                <TextField {...params} fullWidth
                           id={"startDateFrom"}
                           error={error !== undefined}
                           helperText={error ? error.message : ""}
                />} inputFormat={"L"}
        />)
    const renderStartDateTo = (field: any, error: any, formState: any, values: any) => (
        <DatePicker
            views={['day']}
            label={t('filters.startDateTo')}
            value={field.value}
            onChange={field.onChange}
            minDate={values["startDateFrom"] ? values["startDateFrom"] : ""}
            renderInput={(params) =>
                <TextField {...params} fullWidth
                           id={"startDateTo"}
                           error={error !== undefined}
                           helperText={error ? error.message : ""}
                />} inputFormat={"L"}
        />)
    const renderEndDateFrom = (field: any, error: any, formState: any, values: any) => (
        <DatePicker
            views={['day']}
            label={t('filters.endDateFrom')}
            value={field.value}
            onChange={field.onChange}
            maxDate={values["endDateTo"] ? values["endDateTo"] : ""}
            renderInput={(params) =>
                <TextField {...params} fullWidth
                           id={"endDateFrom"}
                           error={error !== undefined}
                           helperText={error ? error.message : ""}
                />} inputFormat={"L"}
        />)
    const renderEndDateTo = (field: any, error: any, formState: any, values: any) => (
        <DatePicker
            views={['day']}
            label={t('filters.endDateTo')}
            value={field.value}
            onChange={field.onChange}
            minDate={values["endDateFrom"] ? values["endDateFrom"] : ""}
            renderInput={(params) =>
                <TextField {...params} fullWidth
                           id={"endDateTo"}
                           error={error !== undefined}
                           helperText={error ? error.message : ""}
                />} inputFormat={"L"}
        />)

    const mainFields = {
        customerName: renderCustomerName,
        clientType: renderClientType,
        entrySource: renderEntrySource
    }

    const fields = {
        taxOrVat: renderTaxOrVat,
        siren: renderSiren,
        siret: renderSiret,
        causal: renderCausal,
        entryDateFrom: renderEntryDateFrom,
        entryDateTo: renderEntryDateTo,
        startDateFrom: renderStartDateFrom,
        startDateTo: renderStartDateTo,
        endDateFrom: renderEndDateFrom,
        endDateTo: renderEndDateTo
    }

    const onDownloadTemplate = () => {
        if (isArchived) {
            downloadReportArchived().then(response => {
                setOpenDownloadModal();
            }).catch(e => {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t("importErrors.downloadError"),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
            })
        } else {
            downloadReport().then(response => {
                setOpenDownloadModal();
            }).catch(e => {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t("importErrors.downloadError"),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
            })
        }

    }

    const toolbar = {
        renderActions: () =>
            <>
                {hasScope(BLACK_LIST_SCOPE_DOWNLOAD) &&
                    <Button
                        disabled={emptyBlackList === 0}
                        variant={"outlined"} size="small"
                        onClick={() => onDownloadTemplate()}>
                        <FileDownloadRounded/>
                        {isArchived ?
                            t('buttons.downloadCsvTemplateArchived')
                            : t('buttons.downloadCsvTemplate')
                        }
                    </Button>
                }
                {!isArchived &&
                    <>
                        {hasScope(BLACK_LIST_SCOPE_UPLOAD_FCA) &&
                            <Button variant={"outlined"} size="small"
                                    onClick={() => setOpenUploadModal(true)}
                                    component="label" startIcon={<FileUploadRounded/>}>
                                {t('buttons.importFromFile')}
                            </Button>}
                        {hasScope(BLACK_LIST_SCOPE_MASSIVE_ARCHIVE) &&
                            <Button variant={"outlined"} size="small"
                                    onClick={() => setOpenMassiveArchiveModal(true)}
                                    component="label" startIcon={<FileUploadRounded/>}>
                                {t('buttons.massiveArchive')}
                            </Button>}
                        {hasScope(BLACK_LIST_SCOPE_CREATE) &&
                            <Button size="small" startIcon={<LibraryAddRounded/>}
                                    onClick={() => {
                                        navigate('/finessecurity/watchlist/addCustomer');
                                    }}>
                                {t('buttons.addCustomer')}
                            </Button>}
                    </>
                }
            </>
    }

    const columns: ColDef[] = [
        {
            field: "customer",
            headerName: t('listColumns.name'),
            sortable: false,
            sort: undefined,
            valueGetter: (params: any) => (params.data.business_name ? params.data.business_name :
                (params.data.last_name ? (params.data.last_name + " " + params.data.first_name) :
                    params.data.full_name)),
            tooltipValueGetter: (params: any) => (params.data.business_name ? params.data.business_name : (params.data.last_name ? (params.data.last_name + " " + params.data.first_name) :
                params.data.full_name)),
        },
        {
            field: "CfPiva",
            headerName: t('listColumns.CfPiva'),
            tooltipField: "CfPiva",
            sortable: false,
            sort: undefined,
            valueGetter: (params: any) => (params.data.vat_number ? params.data.vat_number : params.data.tax_code ? params.data.tax_code : ""),
            tooltipValueGetter: (params: any) => (params.data.vat_number ? params.data.vat_number : params.data.tax_code ? params.data.tax_code : ""),
        },
        {
            field: "siren",
            headerName: t('listColumns.siren'),
            tooltipField: "siren",
            sortable: false,
            sort: undefined,
            valueGetter: (params: any) => (params.data.siren ? params.data.siren : ""),
            tooltipValueGetter: (params: any) => (params.data.siren ? params.data.siren : ""),
        },
        {
            field: "siret",
            headerName: t('listColumns.siret'),
            tooltipField: "siret",
            sortable: false,
            sort: undefined,
            valueGetter: (params: any) => (params.data.siret ? params.data.siret : ""),
            tooltipValueGetter: (params: any) => (params.data.siret ? params.data.siret : ""),
        },
        {
            field: "client_type",
            headerName: t('filters.clientType'),
            sortable: false,
            sort: undefined,
            cellRenderer: (params: any) => getClientTypeLabel(params.value.client_type_code),
            tooltipValueGetter: (params: any) => getClientTypeLabel(params.value.client_type_code),
        },
        {
            field: "entry_origin",
            headerName: t('filters.entrySource'),
            cellRenderer: (params: any) => getEntrySourcelLabel(params.value.entry_origin_code),
            tooltipValueGetter: (params: any) => getEntrySourcelLabel(params.value.entry_origin_code),
            sortable: false,
            sort: undefined,
        },
        {
            field: "causal",
            headerName: t('filters.causal'),
            sortable: false,
            sort: undefined,
            cellRenderer: (params: any) => getCausalLabel(params.value.causal_code),
            tooltipValueGetter: (params: any) => getCausalLabel(params.value.causal_code),
        },
        {
            field: "create_datetime",
            headerName: t('listColumns.entryDate'),
            cellRenderer: (params: any) => params.value ? dayjs(params.value).format("L") : "",
            unSortIcon: true,
        },
        {
            field: "date_start_bl",
            headerName: t('listColumns.startDateBL'),
            cellRenderer: (params: any) => params.value ? dayjs(params.value).format("L") : "",
            unSortIcon: true,
        },
        {
            field: "date_end_bl",
            headerName: t('listColumns.endDateBL'),
            cellRenderer: (params: any) => params.value ? dayjs(params.value).format("L") : "",
            unSortIcon: true,
        },
        {
            field: "update_datetime",
            headerName: t('listColumns.dateLastChange'),
            cellRenderer: (params: any) => params.value ? dayjs(params.value).format("L") : "",
            unSortIcon: true,
        },
        {
            field: "entry_user_bl",
            headerName: t('editBlackList.userEntry'),
            unSortIcon: true,
        },
        {
            field: "_actions",
            headerName: t('listColumns.action'),
            pinned: 'right',
            lockPosition: 'right',
            lockPinned: true,
            sortable: false,
            hide: !hasScope(BLACK_LIST_SCOPE_DETAIL_BL),
            cellRenderer: (params: ICellRendererParams) => {
                return (
                    <Box display="flex" justifyContent="center" alignItems="center">
                        <IconButton color={"accent"}
                                    onClick={() => {
                                        window.open(`/finessecurity/watchlist/detail/${params.data.id}`, "_blank");
                                    }}>
                            <DescriptionRounded/>
                        </IconButton>
                    </Box>
                )
            }
        }
    ];

    function createDatasource(filters: any) {
        return {
            getRows: async (params: IServerSideGetRowsParams) => {
                let filterTemp = {...filters};
                filterTemp.offset = params.request.startRow ? params.request.startRow : 0;
                filterTemp.limit = (params.request.endRow ? params.request.endRow : 10) - filterTemp.offset;
                filterTemp.sort = params.request.sortModel.length === 0 ? null : replaceUnderscoreText(params.request.sortModel[0].colId);
                filterTemp.order = params.request.sortModel.length === 0 ? null : params.request.sortModel[0].sort;
                filterTemp.search = searchInput;

                try {
                    let data = isArchived ? await getBlackListArchived(filterTemp) : await getBlackList(filterTemp);

                    if (data.totalElements === 0) {
                        gridRef.current!.api.showNoRowsOverlay();
                    } else {
                        gridRef.current!.api.hideOverlay();
                    }
                    setEmptyBlackList(data.totalElements)
                    params.success({
                        rowData: data?.content,
                        rowCount: data?.totalElements
                    });
                } catch (e) {
                    params.fail();
                }
            }
        };
    }

    function replaceUnderscoreText(columnId: string) {
        let result = "";
        for (let i = 0; i < columnId.length; i++) {
            if (columnId[i] === "_" && i < columnId.length - 1) {
                result += columnId[i + 1].toUpperCase();
                i++;
            } else {
                result += columnId[i];
            }
        }
        return result;
    }

    const gridOptions: GridOptions = {
        getRowId: (params: GetRowIdParams) => params.data['id'],
        suppressRowClickSelection: true,
        domLayout: 'autoHeight',
        rowModelType: 'serverSide',
        pagination: true,
        paginationPageSize: 10,
        cacheBlockSize: 10,
        defaultColDef: {
            sortable: true,
            resizable: true,
            wrapHeaderText: true,
            autoHeight: true,
        },
        columnDefs: columns,
        serverSideInfiniteScroll: true,
        localeText: agGridLocale,
        serverSideDatasource: createDatasource(filters)
    };

    const noRowsOverlayComponent = useMemo<any>(() => {
        return EmptyState;
    }, []);

    const noRowsOverlayComponentParams = useMemo<any>(() => {
        return {
            title: t("noValues"),
            content: isArchived ? "" : t("noValuesDescription")
        };
    }, []);

    const retrieveList = () => {
        gridRef?.current?.api?.setServerSideDatasource(createDatasource(filters));
        setDoSearchFlag(false);
    };

    const handleSetFilters = (data: any) => {
        setFilters(data);
        setDoSearchFlag(true);
    }

    useEffect(() => {
        if (doSearchFlag) {
            retrieveList();
        }
    }, [doSearchFlag]);

    useEffect(() => {
        if (blackListTableShouldUpdate) {
            gridRef?.current?.api?.setServerSideDatasource(createDatasource(filters));
            setBlackListTableShouldUpdate(false);
        }
    }, [blackListTableShouldUpdate]);

    const uploadFCABankFile = (fileForImport: File) => {
        let fileExtension = fileForImport.name.split('.').pop();
        if (fileExtension!.toLowerCase() === "xlsx" || fileExtension!.toLowerCase() === "xls") {
            // Upload file
            importFile(fileForImport, fileForImport.name.split('.')[0])
                .then(response => {
                    if (response.data !== "") {
                        dispatchGlobalData({
                            type: setSnackbar,
                            payload: {
                                snackbar: {
                                    message: t("createForm.successImport"),
                                    type: snackbarTypes.success,
                                    show: true,
                                    autoClose: true,
                                }
                            }
                        });
                        setBlackListTableShouldUpdate(true);
                        setOpenUploadModal(false);
                    } else {
                        if (response.message) {
                            // specific error
                            setUploadErrorMessage(t(`importErrors.${response.message}`));
                        } else {
                            // generic error
                            setUploadErrorMessage(t("importErrors.generic"));
                        }
                        setOpenUploadWarning(true);
                    }
                })
                .finally(() => {
                    setFileForImport(undefined);
                });
        } else {
            setUploadErrorMessage(t('importErrors.wrongFileFormat'));
            setOpenUploadWarning(true);
            setFileForImport(undefined);
        }

    }

    const massiveArchiveUploadFile = (fileForImport: File) => {
        let fileExtension = fileForImport.name.split('.').pop();
        if (fileExtension!.toLowerCase() === "xlsx" || fileExtension!.toLowerCase() === "xls") {
            massiveArchiveUpload(fileForImport, fileForImport.name.split('.')[0], i18n.language)
                .then(response => {
                    if (response && response.id) {
                        setOpenMassiveArchiveModal(false);
                        setOpenMassiveArchiveAck(true);
                    } else {
                        setUploadErrorMessage(t("importErrors.generic"));
                        setOpenUploadWarning(true);
                    }
                })
                .finally(() => {
                    setFileForImport(undefined);
                });
        } else {
            setUploadErrorMessage(t('importErrors.wrongFileFormat'));
            setOpenUploadWarning(true);
            setFileForImport(undefined);
        }
    }

    const reset = () => {
        setFilters([]);
    };

    return (
        <>
            <>
                <AdvancedFilter validationObj={validationObj} fields={fields} defaultValues={filterDefaultValues}
                                mainFields={mainFields} filters={filters} onReset={reset}
                                setFilters={handleSetFilters}/>

                <Grid container>
                    <Grid item xs={12} sx={{padding: "16px"}}>
                        <AgGridCustomTable gridOptions={gridOptions}
                                           gridRef={gridRef}
                                           toolbar={toolbar}
                                           noRowsOverlayComponent={noRowsOverlayComponent}
                                           noRowsOverlayComponentParams={noRowsOverlayComponentParams}/>
                    </Grid>
                </Grid>
                <CustomModalBL
                    open={openUploadWarning}
                    onClose={() => setOpenUploadWarning(false)}
                    title={t('importErrors.title')}
                    cancelButton={t('buttons.close')}
                    content={uploadErrorMessage}
                    titleIcon={<WarningRounded color={"error"}/>}/>
                <CustomModalContent
                    isDisabled={disableButton}
                    open={openUploadModal}
                    onClose={() => {
                        setOpenUploadModal(false);
                        setUploadErrorMessage(t('importErrors.wrongFileFormat'));
                    }}
                    cancelButton={t('buttons.close')}
                    title={t('buttons.importFromFile')}
                    content={
                        <>
                            <FileUploader errorMessage={uploadErrorMessage}
                                          label={t('buttons.selectFile')}
                                          onUpload={(file: File) => {
                                              uploadFCABankFile(file);
                                          }}
                                          acceptedFiles={{'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xls', '.xlsx']}}
                            />
                        </>
                    }
                />
            </>

            {openDownloadModal && (
                <DownloadModal setOpenDownloadModal={setOpenDownloadModal}/>
            )}

            <CustomModalContent
                isDisabled={disableButton}
                open={openMassiveArchiveModal}
                onClose={() => {
                    setOpenMassiveArchiveModal(false);
                    setUploadErrorMessage(t('importErrors.wrongFileFormat'));
                }}
                cancelButton={t('buttons.close')}
                title={t('buttons.massiveArchive')}
                content={
                    <>
                        <FileUploader errorMessage={uploadErrorMessage}
                                      label={t('buttons.selectFile')}
                                      onUpload={(file: File) => {
                                          massiveArchiveUploadFile(file);
                                      }}
                                      acceptedFiles={{'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xls', '.xlsx']}}
                        />
                    </>
                }
            />

            {openMassiveArchiveAck && (
                <MassiveArchiveModal setOpenModal={() => setOpenMassiveArchiveAck(false)}/>
            )}
        </>

    )
}

export default BlackListPage;